export const getInterviewVideoId = (questionId) =>
    `interview-video-${questionId}`;
export const getCultureFitVideoId = () => `culture-fit-video`;

const MAIN_MODULES = [
    'culture-fit',
    'speaking',
    'interview',
    'mental-test',
    'questionnaire',
    'culture-fit-questionnaire',
    'data-collection-scan',
];

const hasOnlyModule = (scanModules, id) =>
    scanModules.filter((m) => MAIN_MODULES.includes(m.id)).length === 1 &&
    scanModules.some((m) => m.id === id);

export const isOnlyCultureFit = (scanModules) =>
    hasOnlyModule(scanModules, 'culture-fit');
export const isOnlyInterview = (scanModules) =>
    hasOnlyModule(scanModules, 'speaking') ||
    hasOnlyModule(scanModules, 'interview');
